import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import RadCreatePage from './rad-create'
import RadListPage from './rad-list'
import RadUpdatePage from './rad-update'

const radRoutes: Route[] = [
  {
    path: Paths.RAD_LIST_PAGE,
    element: <RadListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.RAD_CREATE_PAGE,
    element: <RadCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.RAD_UPDATE_PAGE,
    element: <RadUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default radRoutes
